import React, { Component } from 'react';
import { Table } from 'antd';
import Helper from '../utils/helper';

interface Props {
    columns?: any[];
    rows: any[];
    handleTableChange?: any;
    pagination: any;
    loading: boolean;
    scrolling: any;
    genericColumnsNames?: any;
    title?: string; 
}

class CallCenterTable extends Component<Props> {
    render() {
        const { columns, rows, handleTableChange, pagination, loading, scrolling, title } = this.props;
        return (
            <div style={{ maxWidth: "100%" }}>
                <Table
                    className="p-1 border rounded-lg shadow-sm callCenterTable"
                    columns={columns ? columns?.map((col: any) => {
                        return {
                            ...col,
                            title: Helper.unCamelCase(col?.title) 
                        };
                    }) 
                    : this.props?.genericColumnsNames}
                    dataSource={rows}
                    scroll={scrolling}
                    onChange={handleTableChange}
                    pagination={pagination}
                    loading={loading}
                    bordered={false}
                    title={() => <h2 className="font-medium text-md">{title || "Call Center: User Info"}</h2>}
                />
            </div>
        );
    }
}

export default CallCenterTable;
